import React, { useState } from 'react';
import { Button, Modal, ModalContent, ModalTitle, ModalActions, FormControlLabel, Radio, Grid, SelectField, Option, Typography } from '@deere/fuel-react';
import { getSelfServiceSurveysForPromotion } from '../../services/campaign.service';
import { useEffect } from 'react';
import { PROMOTE_SURVEY_TITLE, PROMOTE_NEW_SURVEY_OPTION, PROMOTE_EXISTING_SURVEY_OPTION, PROMOTE_NEW_SURVEY_LABEL, PROMOTE_EXISTING_SURVEY_LABEL, PROMOTE_EXISTING_SURVEY_SELECT_LABEL, CONTINUE_BTN, CANCEL_BTN, PROMOTE_EXISTING_SURVEY_FETCH_ERROR } from '../../utils/surveyLiterals';
import { useUserInfo } from "../../providers/userProvider";

export const PromoteSurveyModal = ({ show, handleClose, handleContinue, authState }) => {
  const [selectedOption, setSelectedOption] = useState(PROMOTE_NEW_SURVEY_OPTION);
  const [selectedExistingSurveyId, setSelectedExistingSurveyId] = useState("");
  const [surveysForPromotion, setSurveysForPromotion] = useState([]);
  const [loading, setLoading] = useState(true);
  const [errorDuringSurveyFetch, setErrorDuringSurveyFetch] = useState(false);
  const userInfo = useUserInfo();

  const loadSurveysForPromotion = () => {
      setLoading(true);
      setErrorDuringSurveyFetch(false);
      
      if(authState && authState?.accessToken && userInfo){
        getSelfServiceSurveysForPromotion(userInfo.userID, authState.accessToken.accessToken)
        .then((selfServicesurveys) => {
            //get just the newest version of each survey for promotion
            const newestSurveys = [];
            const surveyMap = new Map();
            selfServicesurveys.forEach((survey) => {
                if (!surveyMap.has(survey.code) || Number(survey.templateRevision) > Number(surveyMap.get(survey.code).templateRevision)) {
                    surveyMap.set(survey.code, survey);
                }
            });
            surveyMap.forEach((survey) => newestSurveys.push(survey));
            setSurveysForPromotion(newestSurveys);
            setLoading(false);
        })
        .catch((err) => {
            console.log(err);
            setLoading(false);
            setErrorDuringSurveyFetch(true);
        });
      }
  };

  useEffect(() => {
    loadSurveysForPromotion();
  }, [show, authState,userInfo]);

  const onClose = () => {
    setSelectedOption(PROMOTE_NEW_SURVEY_OPTION);
    setSelectedExistingSurveyId("");
    handleClose();
  };

  const onContinue = () => {
    handleContinue(selectedOption, selectedExistingSurveyId);
    setSelectedOption(PROMOTE_NEW_SURVEY_OPTION);
    setSelectedExistingSurveyId("");
  };

  return (
    <Modal
      open={show}
      onClose={onClose}
      aria-labelledby="promote-survey-modal-title"
      aria-describedby="promote-survey-modal-description"
    >
      <ModalTitle id="promote-survey-modal-title">{PROMOTE_SURVEY_TITLE}</ModalTitle>
      <ModalContent id="promote-survey-modal-description">
        <Grid container direction="column">
          <Grid item>
            <FormControlLabel
              control={<Radio checked={selectedOption === PROMOTE_NEW_SURVEY_OPTION} onChange={() => setSelectedOption(PROMOTE_NEW_SURVEY_OPTION)} />}
              label={PROMOTE_NEW_SURVEY_LABEL}
            />
          </Grid>
          <Grid item>
            <FormControlLabel
              control={<Radio checked={selectedOption === PROMOTE_EXISTING_SURVEY_OPTION} onChange={() => setSelectedOption(PROMOTE_EXISTING_SURVEY_OPTION)} />}
              label={PROMOTE_EXISTING_SURVEY_LABEL}
            />
          </Grid>
          {selectedOption === PROMOTE_EXISTING_SURVEY_OPTION && (
            <Grid item>
              { errorDuringSurveyFetch && (
                <Typography color="error">{PROMOTE_EXISTING_SURVEY_FETCH_ERROR}</Typography>
              )}
              <SelectField loading={loading} label={PROMOTE_EXISTING_SURVEY_SELECT_LABEL} value={selectedExistingSurveyId} onChange={(e) => setSelectedExistingSurveyId(e.target.value)} notched="true">
                <Option value="">{PROMOTE_EXISTING_SURVEY_SELECT_LABEL}</Option>
                {surveysForPromotion.map((survey) => (
                  <Option key={survey.id} value={survey.id}>
                    {`${survey.code} - ${survey.description}`}
                  </Option>
                ))}
              </SelectField>
            </Grid>
          )}
        </Grid>
      </ModalContent>
      <ModalActions>
        <Button onClick={onClose} variant="secondary">
          {CANCEL_BTN}
        </Button>
        <Button onClick={onContinue} variant="primary" disabled={selectedOption === PROMOTE_EXISTING_SURVEY_OPTION && !selectedExistingSurveyId}>
          {CONTINUE_BTN}
        </Button>
      </ModalActions>
    </Modal>
  );
};

